export default __webpack_public_path__ + "static/media/loading.d9173d9e.gif";